import { render, staticRenderFns } from "./RevenuePerMonthCompare.vue?vue&type=template&id=0a2875d1"
import script from "./RevenuePerMonthCompare.vue?vue&type=script&lang=ts"
export * from "./RevenuePerMonthCompare.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a2875d1')) {
      api.createRecord('0a2875d1', component.options)
    } else {
      api.reload('0a2875d1', component.options)
    }
    module.hot.accept("./RevenuePerMonthCompare.vue?vue&type=template&id=0a2875d1", function () {
      api.rerender('0a2875d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/RevenuePerMonthCompare.vue"
export default component.exports